import React from 'react';
import './Loading.Style.css';

export const Loading = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner" />
    </div>
  );
};
